import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  if (localStorage.getItem('liiji.token')) {
    return true;
  }
  return inject(Router).createUrlTree(['/signin'], { queryParams: { returnUrl: state.url } });
};

export const depositGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  if (!localStorage.getItem('liiji.token')) {
    return router.createUrlTree(['/signin'], { queryParams: { returnUrl: '/portfolio' } });
  }
  const known = auth.user();
  if (known) {
    return known.detailsPending ? router.createUrlTree(['/details']) : true;
  }
  return auth.ensureUser().pipe(map((user) => (user?.detailsPending ? router.createUrlTree(['/details']) : true)));
};
